import { mapGetters } from 'vuex'

export const mixinPtoProjectPTOJobSelect = {
  computed: {
    ...mapGetters('handbook/pto', {
      projectPTOJobList: 'getProjectPTOJobList'
    })
  },
  methods: {
    GETProjectPTOJobList ({ search = null }) {
      return this.$store.dispatch('handbook/pto/GETProjectPTOJobList', {
        projectId: this.$route.params.projectId,
        search
      })
    }
  }
}
